import React from 'react'
import styled, { css } from 'styled-components'
import { mergeClassnames } from '@mote/helpers/dom'

export const Content = ({ children, className, variant, ...rest }) => {
  return (
    <Root
      className={mergeClassnames('content', className)}
      variant={variant}
      {...rest}
    >
      {children}
    </Root>
  )
}

const Root = styled.section`
  margin: 0 auto;
  width: 100%;

  ${({ variant }) => {
    switch (variant) {
      case 'narrow':
        return css`
          max-width: 992px;
          padding: 0 16px;

          @media (max-width: 639px) {
            padding: 0 24px;
          }
        `
      case 'wide':
        return css`
          max-width: 1600px;
          padding: 0 16px;

          @media (max-width: 639px) {
            padding: 0 24px;
          }
        `
      default:
        return css`
          max-width: 1200px;
          padding: 0px 30px;

          @media (max-width: 1279px) {
            padding: 0px 60px;
          }

          @media (max-width: 991px) {
            padding: 0 40px;
          }

          @media (max-width: 639px) {
            padding: 0 20px;
          }
        `
    }
  }};
`
